import {
  CHANGE_BASE_COMPARISON_SURVEY,
  CHANGE_DEPARTMENT_SEGMENT_GROUPS_SEARCH_KEYWORD,
  CLEAR_COMPARISON_SURVEY_CONDITION,
  FAILURE_FETCH_COMPARISON_SURVEY_DATA,
  FAILURE_FETCH_ENGAGEMENT_SURVEY_SEGMENTS,
  REMOVE_COMPARISON_SURVEY,
  REQUEST_FETCH_COMPARISON_SURVEY_DATA,
  REQUEST_FETCH_ENGAGEMENT_SURVEY_SEGMENTS,
  RESET_COMPARISON_SURVEY_DATA,
  SET_ACTIVE_ENGAGEMENT_SURVEY_SEGMENT,
  SET_COMPARISON_CURRENT_SURVEY,
  SET_FILTERED_DEPARTMENT_SEGMENT_GROUPS,
  SUCCESS_FETCH_COMPARISON_SURVEY_DATA,
  SUCCESS_FETCH_ENGAGEMENT_SURVEY_SEGMENTS,
  TOGGLE_ENGAGEMENT_SURVEY_SEGMENTS_GROUP_CHECK_BOX,
} from 'actions/actionTypes';
import {
  CheckBoxTargetType,
  ComparisonActionTypes,
  SegmentTypes,
  SuccessFetchComparisonSurveyDataPayload,
} from 'types/backend/engagementSurvey/comparison';
import { SurveyTypes } from 'types/backend/engagementSurvey/result';

// セグメント取得リクエスト
export const requestFetchEngagementSurveySegments = (
  comparisonSurvey: SurveyTypes,
): ComparisonActionTypes => ({
  type: REQUEST_FETCH_ENGAGEMENT_SURVEY_SEGMENTS,
  comparisonSurvey,
});

// セグメント取得リクエスト 成功
export const successFetchEngagementSurveySegments = (
  payload: SegmentTypes[],
): ComparisonActionTypes => ({
  type: SUCCESS_FETCH_ENGAGEMENT_SURVEY_SEGMENTS,
  payload,
});

// セグメント取得リクエスト 失敗
export const failureFetchEngagementSurveySegments = (): ComparisonActionTypes => ({
  type: FAILURE_FETCH_ENGAGEMENT_SURVEY_SEGMENTS,
});

// 対象のセグメントをセットする
export const setEngagementSurveySegment = (id: string): ComparisonActionTypes => ({
  type: SET_ACTIVE_ENGAGEMENT_SURVEY_SEGMENT,
  id,
});

// セグメントグループ チェックボックス
export const toggleSegmentsGroupCheckBox = (target: CheckBoxTargetType): ComparisonActionTypes => ({
  type: TOGGLE_ENGAGEMENT_SURVEY_SEGMENTS_GROUP_CHECK_BOX,
  target,
});

// 部署検索キーワード(ローカル検索)
export const changeDepartmentSegmentGroupsSearchKeyword = (
  departmentSegmentGroupsSearchKeyword: string,
): ComparisonActionTypes => ({
  type: CHANGE_DEPARTMENT_SEGMENT_GROUPS_SEARCH_KEYWORD,
  departmentSegmentGroupsSearchKeyword,
});

// 部署検索
export const setFilteredDepartmentSegmentGroups = (
  departmentSegmentGroupsSearchKeyword: string,
): ComparisonActionTypes => ({
  type: SET_FILTERED_DEPARTMENT_SEGMENT_GROUPS,
  departmentSegmentGroupsSearchKeyword,
});

// 比較データ取得リクエスト
export const requestFetchComparisonSurveyData = (surveyId: string): ComparisonActionTypes => ({
  type: REQUEST_FETCH_COMPARISON_SURVEY_DATA,
  surveyId,
});

// 比較データ取得リクエスト成功
export const successFetchComparisonSurveyData = (
  payload: SuccessFetchComparisonSurveyDataPayload,
): ComparisonActionTypes => ({
  type: SUCCESS_FETCH_COMPARISON_SURVEY_DATA,
  payload,
});

// 比較データ取得リクエスト失敗
export const failureFetchComparisonSurveyData = (): ComparisonActionTypes => ({
  type: FAILURE_FETCH_COMPARISON_SURVEY_DATA,
});

// サーベイをセット
export const setComparisonCurrentSurvey = (survey: SurveyTypes): ComparisonActionTypes => ({
  type: SET_COMPARISON_CURRENT_SURVEY,
  survey,
});

// 比較データベース変更
export const changeBaseComparisonSurvey = (index: number): ComparisonActionTypes => ({
  type: CHANGE_BASE_COMPARISON_SURVEY,
  index,
});

// 比較データ削除
export const removeComparisonSurvey = (index: number): ComparisonActionTypes => ({
  type: REMOVE_COMPARISON_SURVEY,
  index,
});

// 対象条件リセット
export const clearComparisonSurveyCondition = (): ComparisonActionTypes => ({
  type: CLEAR_COMPARISON_SURVEY_CONDITION,
});

// リセット
export const resetComparisonSurveyData = (): ComparisonActionTypes => ({
  type: RESET_COMPARISON_SURVEY_DATA,
});
